import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { push } from 'connected-react-router';
import Button from '@components/uielements/button';
import IntlMessages from '@components/utility/intlMessages';
import SignInStyleWrapper from './signin.style';
import authActions from '@redux/auth/actions';

function SignIn() {
  const isLoggedIn = useSelector((state) => state.Auth.user !== null);
  const appStatus = useSelector((state) => state.Auth.appStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(push('/admin'));
    }
  }, [isLoggedIn, dispatch]);

  const onDIGILogin = async () => {
    dispatch(authActions.login());
  };

  return (
    <SignInStyleWrapper className="isoSignInPage">
      <div className="isoLoginContentWrapper">
        <div className="isoLoginContent">
          <div className="isoLogoWrapper">
            <IntlMessages id="page.signInTitle" />
          </div>
          {appStatus === 'checkingAuth' && <Spin />}
          {appStatus === 'ready' && (
            <div className="isoSignInForm">
              <Button onClick={onDIGILogin}>Login with DIGI</Button>
            </div>
          )}
        </div>
      </div>
    </SignInStyleWrapper>
  );
}

export default SignIn;
